import React, { createContext, useContext, useState } from "react";
import { languageOptions } from "./LanguageHelpers/LangOptions";
import { translations } from "./LanguageHelpers/Translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem("language") || "tr");
  const [languageProps, setLanguageProps] = useState(languageOptions[language])

  const changeLanguage = (lang) => {
    if (languageOptions[lang]){
        localStorage.setItem("language", lang);
        setLanguage(lang)
        setLanguageProps(languageOptions[lang])
    }
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, languageProps, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);